const ModalType = Object.freeze({
  CHECK_ELIGIBILITY: 'check-eligibility',
  PRICES: 'prices',
  HEADBAND: 'headband',
});

export default ModalType;
